/**
 * A scanned value that is an http(s) URL is never a product barcode — product
 * codes are EAN/UPC/CODE128 digits or short SKUs. QR codes printed on internal
 * documents (e.g. delivery notes) and links opened via in-app browsers encode
 * full URLs; feeding one into the product-barcode lookup only yields repeated
 * 404s while the code stays in the camera frame. Callers short-circuit the
 * lookup on a match and tell the operator it is the wrong kind of code.
 */
export function looksLikeUrl(code: string): boolean {
    return /^https?:\/\//i.test(code.trim())
}

// QR trên phiếu đóng gói = `{APP_BASE_URL}/stock-out-notes/{mã đơn}`.
const PACKING_SLIP_QR_RE = /^https?:\/\/[^\s]*\/stock-out-notes\/([^/?#\s]+)/i

/**
 * Máy quét cắm như bàn phím gõ nguyên URL của QR phiếu đóng gói vào ô tìm
 * kiếm → chỉ giữ mã đơn. Chuỗi khác (người dùng tự gõ) giữ nguyên, kể cả
 * khoảng trắng đang gõ dở.
 */
export function orderCodeFromPackingSlipQr(text: string): string {
    const match = text.trim().match(PACKING_SLIP_QR_RE)
    if (!match) return text
    try {
        return decodeURIComponent(match[1])
    } catch {
        return match[1]
    }
}
